var months = new Array ('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec')

var fb_max_shares,
    fb_shares,
    tw_max_shares,
    tw_shares;

var fb_locked = false,
    tw_locked = false;

$(document).ready(function(){
	var 
	dateText = $('#date').text(),
 	myString = dateText,
 	newStr = myString.slice(0,2),
	gtm = ' GMT+0100',
	slice = dateText.slice(0,2),
	dateText2 = dateText.replace(newStr, months[slice-1] ),
	hour = $('#hour').text(),
	dateR = dateText2.replace(/\./g, ' '),
	date = dateR + " " + hour + gtm;
 
	setInterval(function(){
	    // set whatever future date / time you want here, together with
	    // your timezone setting...
	    var future = new Date(date);
	    var now = new Date();
	    var difference = Math.floor((future - now) / 1000);
	    var seconds = fixIntegers(difference % 60);
	    difference = Math.floor(difference / 60);
	    var minutes = fixIntegers(difference % 60);
	    difference = Math.floor(difference / 60);
	    var hours = fixIntegers(difference % 24);
	    difference = Math.floor(difference / 24);
	    var days = difference;
      
	    $("#days").text(days);
	    $("#hours").text(hours);
	    $("#minutes").text(minutes);
	    $("#seconds").text(seconds);

	}, 1000);

	function fixIntegers(integer)
	{
	    if (integer < 0)
	        integer = 0;
	    if (integer < 10)
	        return "0" + integer;
	    return "" + integer;
	}
	
  // get the data
  fb_max_shares = $('#fb_max_shares').text();
  fb_shares = $('#fb_shares').text();
  tw_max_shares = $('#tw_max_shares').text();
  tw_shares = $('#tw_shares').text();
  
  
  // calculate the percentage
  var fb_percentage = 100/(fb_max_shares/parseInt(fb_shares)),
    tw_percentage = 100/(tw_max_shares/parseInt(tw_shares));
  
  $('#fb_curr_stats').text(parseInt(fb_shares));
  $('#tw_curr_stats').text(parseInt(tw_shares));
  
  setTimeout(function() {
      $('#fb_percentage').css('width', fb_percentage+'%');
      $('#tw_percentage').css('width', tw_percentage+'%');
  }, 1000);
});

// make an ajax call to a PHP file which updates the couneter info
function update_counter(field_name){
  // check if the user has shared the page
  if( field_name == 'fb-shares' && fb_locked ){
    alert('You have already shared the page on Facebook.');
    return false;
  }
  
  // check if the user has shared the page
  if( field_name == 'tw-shares' && tw_locked ){
    alert('You have already shared the page on Twitter.');
    return false;
  }
  
  product_id = $('#product_id').text();
  
  // json object sent to the php file
  var post_data = 
      {
        "product_id": product_id,
        "social_network": field_name
      }
  ;
  
  $.ajax({
    type : 'POST',
    url : 'http://reellabs.com/pv-shop/like.php',
    data: post_data,
    success: function(data){
      if( field_name == 'fb-shares' ){
        fb_shares = parseInt(fb_shares)+1;
        var fb_percentage = 100/(fb_max_shares/parseInt(fb_shares));
        $('#fb_percentage').css('width', fb_percentage+'%');
        $('#fb_curr_stats').text( parseInt($('#fb_curr_stats').text())+1 );
        fb_locked = true;
      }
      
      if( field_name == 'tw-shares' ){
        tw_shares = parseInt(tw_shares)+1;
        var tw_percentage = 100/(tw_max_shares/parseInt(tw_shares));
        $('#tw_percentage').css('width', tw_percentage+'%');
        $('#tw_curr_stats').text( parseInt($('#tw_curr_stats').text())+1 );
        tw_locked = true;
      }
    }
  })
}

// <div id="date">2014.02.15</div>